import { render, staticRenderFns } from "./RecommendCard.vue?vue&type=template&id=02b22a74&scoped=true"
import script from "./RecommendCard.vue?vue&type=script&lang=js"
export * from "./RecommendCard.vue?vue&type=script&lang=js"
import style0 from "./RecommendCard.vue?vue&type=style&index=0&id=02b22a74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b22a74",
  null
  
)

export default component.exports